import SecureClient from '../api/secure-client';
import { APP_VERSION } from '../constants';
import { APP_ID } from '../constants';
import fnBrowserDetect from './data-lake/browser-detect';
import withLoginDatalake from './data-lake/with-login-datalake';
import withoutLoginDatalake from './data-lake/without-login-datalake';
import { encrypt } from '../secure';
import { v4 as uuidv4 } from 'uuid';
export const SESSION_KEY_HEADER = 'uuid_wp';

/**
 * Check if a customerId is null, undefined, or an empty string.
 *
 * @param {string | null | undefined} customerId - The customerId to check.
 * @returns {boolean} - True if customerId is null, undefined, or an empty string, otherwise false.
 */
const isCustomerIdNullOrEmpty = (customerId) => {
  return customerId === null || customerId === undefined || customerId === '';
};

/**
 * Concatenates the origin and pathname strings from the window.location object
 * and slices the first 40 characters.
 *
 * @returns {string} - The screen name, which is the first 40 characters of the concatenated string.
 */
const getScreenName = () => {
  const origin = window.location.origin;
  const pathname = window.location.pathname;

  const concatenatedString = origin + pathname;
  return concatenatedString.slice(0, 40);
};

/**
 * Tracker used to track data lake events, mainly involving API calls errors as well as file reader errors
 * @param {string} logEventType - Type of event to be tracked can be [`error`,`event`,`exception`,`device_info`]
 * @param {string} eventName - All caps event name like `API_CALL_ERROR` or `FILE_READER_ERROR`
 * @param {string} eventValue - Event value to be tracked
 * @param {string} customerId - 3.0 customer id
 * @param {string} customerRefNum - 3.0 customer ref num
 * @param {string} Authorization - 3.0 Authorization
 */
const DataLakeTracker = ({
  logEventType = 'event',
  eventName = '_',
  eventValue = '_',
  customerId = null,
  customerRefNum = null,
  Authorization = null,
  isEncrypted = false,
}) => {
  const isAuthenticatedUser = !isCustomerIdNullOrEmpty(customerId)
    ? true
    : false;
  const errorExceptionData = {
    logEventType,
    source: 'WEB_3.0',
    deviceModel: window.navigator.userAgent,
    browser: fnBrowserDetect(),
    browserVersion: navigator.appVersion,
    eventName,
    screenName: getScreenName(),
    errorMessage: eventValue,
  };
  const eventData = {
    logEventType,
    source: 'WEB_3.0',
    deviceModel: window.navigator.userAgent,
    browser: fnBrowserDetect(),
    browserVersion: navigator.appVersion,
    eventName,
    screenName: getScreenName(),
    eventValue,
  };
  let deviceId = window.sessionStorage.getItem('deviceId');
  const dataLakeEventPayload = {
    errorExceptionData:
      logEventType === 'event' || logEventType === 'device_info'
        ? eventData
        : errorExceptionData,
    customerRefNum: customerRefNum,
    deviceId: deviceId,
    appId: APP_ID,
    appVersion: APP_VERSION,
  };

  let APIPayloadToPost = {};
  APIPayloadToPost['appId'] = APP_ID;
  APIPayloadToPost['appVersion'] = APP_VERSION;
  APIPayloadToPost['requestId'] = uuidv4();

  console.log('APIPayloadToPost Before Data: ', APIPayloadToPost);

  if (isAuthenticatedUser) {
    dataLakeEventPayload.customerRefNum = customerRefNum;
    // APIPayloadToPost['data'] = encrypt(customerId, dataLakeEventPayload);
    withLoginDatalake({
      customerId,
      APIPayloadToPost,
      Authorization,
      dataLakeEventPayload,
    });
  } else {
    // APIPayloadToPost['data'] = encrypt(null, dataLakeEventPayload);
    withoutLoginDatalake({
      APIPayloadToPost,
      dataLakeEventPayload,
    });
  }
};
export default DataLakeTracker;
